import React, { useMemo, useState } from 'react';
import { FilterGroupContext } from './FilterGroupContext';

export const FilterGroup: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openFilterId, setOpenFilterId] = useState<string | null>(null);

  const contextValue = useMemo(() => ({ openFilterId, setOpenFilterId }), [openFilterId]);

  return <FilterGroupContext.Provider value={contextValue}>{children}</FilterGroupContext.Provider>;
};
